import { render, staticRenderFns } from "./WearExtensionsBefore.vue?vue&type=template&id=f03e393e&scoped=true"
import script from "./WearExtensionsBefore.vue?vue&type=script&lang=js"
export * from "./WearExtensionsBefore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03e393e",
  null
  
)

export default component.exports